export default "__VITE_ASSET__BQRKhjnQ__"